export default function IconFilter({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12.45 7.02V12.45L15.19 13.97M20.9 12.45C20.9 17.1168 17.1168 20.9 12.45 20.9C7.78319 20.9 4 17.1168 4 12.45C4 7.78319 7.78319 4 12.45 4C17.1168 4 20.9 7.78319 20.9 12.45Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
